<template>
  <DxPopup @hidden="onHidden" :visible="showProcessEPop" :show-close-button="true" :show-title="true" :title="menuTitle" height="850" width="1280" container=".v-application">
    <div class="h-full">
      <DxScrollView
        width="100%"
        height="100%"
        direction="both"
      >
        <OL type="A" style="font-size:12pt;">
          <LI>Website Information - http://hycot.hvs.com.vn</LI>
            <OL type="1" style="font-size:10pt;">
              <LI>Users : All suppliers have commercial relation with HD Hyundai-VietNam ShipBuilding Co., Ltd.(HVS).</LI>
              <LI>WEB BROWSER</LI>
              <img :src="require(`@/assets/images/etc/slide2.jpg`)" width="90%"><br>
              <LI>Login : USER ID and PASSWORD</LI>
                <OL type="i" style="font-size:10pt;">
                  <LI>USER ID:</LI>
                    <OL type="a" style="font-size:10pt;">
                      <LI>USER ID is a supplier code which is created by HVS(Each supplier code, Exp:Supplier code of A company is 10001, B company is 10002, ...).</LI>
                      <LI>
                        If customers do not have a customer code, please contact us at :<br>
                        Purchase Section, Procurement Department, HD Hyundai-VietNam ShipBuilding Co., Ltd.<br>
                        No. 01, Mỹ Giang, Ninh Phước, Ninh Hòa, Khán Hòa, Việt Nam,<br>
                        Tel : 0583.622101, Fax : 0583.622047, E-mail : hvs@hvs.com.vn
                      </LI>
                    </OL>
                  <LI>PASSWORD:</LI>
                    <OL type="a" style="font-size:10pt">
                      <LI>First password for a new user : v + customer code (exp: USER ID : 10001, PASSWORD : 10001).</LI>
                      <LI>You can change to new password by yourself from current password.</LI>
                      <LI>You must be change to new password for every 3 months.</LI>
                      <LI>If you lose or forget your password, in this case the supplier must come to our company directly and bring documents relating to your company to prove with Material department before Material department create a new password(in order to the information security of users.).</LI>
                    </OL>
                    <img :src="require(`@/assets/images/etc/slide4.jpg`)" width="90%"><br>
                    <img :src="require(`@/assets/images/etc/slide5.jpg`)" width="90%"><br>
                </OL>
            </OL>
          <LI>Processing of Website:</LI>
          <img :src="require(`@/assets/images/etc/slide3.jpg`)" width="90%"><br>
            <OL type="1" style="font-size:10pt;">
              <LI>Invoice and Bill Of Lading Management </LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide6.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide7.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide8.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide9.jpg`)" width="90%"><br>
                </OL>       
              <LI>Quotation Request : Our company will select some potentiality supplier to send quotaation request via this site.</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide10.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide11.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide12.jpg`)" width="90%"><br>       
                </OL>
              <LI>P/I(Price Indication) : HVS will send to you a  target price in order to price indication.</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide13.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide14.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide15.jpg`)" width="90%"><br>       
                </OL>
              <LI>Bidđing :</LI>
                <OL>
                  <img :src="require(`@/assets/images/etc/slide16.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide17.jpg`)" width="90%"><br>
                  <img :src="require(`@/assets/images/etc/slide18.jpg`)" width="90%"><br>       
                </OL>
            </OL>
            <img :src="require(`@/assets/images/etc/slide19.jpg`)" width="90%"><br>  
        </OL>
      </DxScrollView>
    </div>
  </DxPopup>
</template>

<script>
import baseview from '@/components/base/baseview'
import { DxPopup } from 'devextreme-vue/popup'
import { DxScrollView } from 'devextreme-vue/scroll-view'

export default {
  name: 'processEPop',
  mixins: [baseview],
  components: {
    DxPopup,
    DxScrollView
  },
  props: {
    showProcessEPop: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  data() {
     return {
       menuTitle: 'HyCOT Process(English)',
       openChk: false
     }
  },
  watch: {
    'showProcessEPop': {
      handler(value, oldValue) {
        if(value) {
          this.init()
        }
      },
      immediate: true
    }
  },
  methods: {
    init() {
    },
    onHidden(e) {
      this.$emit('update:showProcessEPop', false)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>